import { TouchableOpacity as RNTouchableOpacity } from "react-native";
import type { WithLayoutProps } from "~/hoc/withLayoutProps";
import { withLayoutProps } from "~/hoc/withLayoutProps";
import type React from "react";
import type { TouchableOpacityProps as RNTouchableOpacityProps } from "react-native";

export const TouchableOpacity = withLayoutProps(RNTouchableOpacity);

export type TouchableOpacity = React.ElementRef<typeof RNTouchableOpacity>;
export type TouchableOpacityProps = Omit<
  RNTouchableOpacityProps,
  keyof WithLayoutProps
> &
  WithLayoutProps;
